import { useQuery } from "@tanstack/react-query";
import { getJobs } from "../../api/similarity";
import { useAuth } from "../../contexts/AuthContext";
import { dispatchTokenExpiredEvent } from "../../utils/authEvents";
import { useToolScope } from "../../features/toolExperience/useToolScope";
import { useToolListState } from "../../features/toolExperience/useToolListState";
import { WorkList, ToolToolbar } from "../../components/ToolPage";
export default function RecentComparisons() {
  const { user } = useAuth(),
    scope = useToolScope();
  const { state, setState } = useToolListState(scope, "similarity", [
    "all",
    "running",
    "completed",
    "failed",
    "queued",
    "pending",
    "processing",
  ]);
  const query = useQuery({
    queryKey: [
      "tool-experience",
      "recent-comparisons",
      scope?.userId,
      scope?.organizationId,
    ],
    queryFn: () => getJobs(undefined, user, dispatchTokenExpiredEvent),
    enabled: !!scope,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
  const jobs = [...(query.data || [])]
    .sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at))
    .slice(0, 50);
  const filtered = jobs.filter(
    (j) =>
      (state.status === "all" || j.status === state.status) &&
      (!state.q ||
        `${j.name || ""} ${j.sitemap_url || ""}`
          .toLowerCase()
          .includes(state.q.toLowerCase())),
  );
  return (
    <>
      <ToolToolbar
        search={{
          label: "Search recent comparisons",
          value: state.q,
          onChange: (q) => setState({ q }),
        }}
        filters={
          <select
            aria-label="Comparison status"
            value={state.status}
            onChange={(e) => setState({ status: e.target.value })}
          >
            <option value="all">All statuses</option>
            <option value="running">Running</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
          </select>
        }
      />
      <p>
        Search within the latest available comparisons, up to 50. Open a project
        for its history.
      </p>
      <WorkList
        state={query.isLoading ? "loading" : query.isError ? "error" : "ready"}
        emptyContent="No matching recent comparisons."
        errorContent={
          <>
            <p>Could not load recent comparisons.</p>
            <button type="button" onClick={() => query.refetch()}>
              Try again
            </button>
          </>
        }
        items={filtered.map((j) => ({
          id: j.id,
          title: j.name || j.sitemap_url || "Comparison",
          href: `/similarity/${encodeURIComponent(j.project_id)}/jobs/${encodeURIComponent(j.id)}`,
          status: {
            label: j.status,
            tone:
              j.status === "failed"
                ? "danger"
                : j.status === "completed"
                  ? "success"
                  : "info",
          },
          metadata: [
            {
              label: "Created",
              value: new Date(j.created_at).toLocaleDateString(),
            },
          ],
          actions: [],
        }))}
      />
    </>
  );
}
